import { ActivityVariant, ActivityColorClasses, ActivityVariantRule } from '@dss-libs/portal/type/portal-types';

export const activityVariantRules: ActivityVariantRule[] = [
  { pattern: /sign|complete|seal|receipt/, variant: 'success' },
  { pattern: /reject|decline|cancel/, variant: 'danger' },
  { pattern: /remind/, variant: 'warning' },
];

export const activityColorClassMapper = new Map<ActivityVariant, ActivityColorClasses>([
  ['success', { dot: 'bg-success', line: 'bg-success/20' }],
  ['warning', { dot: 'bg-warning', line: 'bg-warning/20' }],
  ['danger', { dot: 'bg-danger-hover', line: 'bg-danger/20' }],
  ['primary', { dot: 'bg-primary', line: 'bg-primary/20' }],
]);

export function getActivityVariant(activity: string): ActivityVariant {
  const lower = (activity ?? '').toLowerCase();
  return activityVariantRules.find(({ pattern }) => pattern.test(lower))?.variant ?? 'primary';
}
